import styled from 'styled-components';

export const ShellWrapper = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
`;

export const TopBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spaces.space4} ${theme.spaces.space5}`};
  border-bottom: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
`;
